export enum VerificationStatusEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Expired = 4
}